import '../../styles/ObservationSetup';
import _ from 'lodash';
import ConfirmationModal from '../../../a2i/js/components/ConfirmationModal';
import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';
import moment from 'moment';
import Preferences from '../lib/preferences';
import React, { PropTypes } from 'react';
import SelectDistrictSchoolAndClassroom from '../../../a2i/js/components/SelectDistrictSchoolAndClassroom';
import SelectStudent from './SelectStudent';
import { Modal } from 'react-bootstrap';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';

let preferences = new Preferences(localStorage);

let ObservationSetup = React.createClass({
	propTypes: {
		classroom: PropTypes.object,
		createObservation: PropTypes.func.isRequired,
		currentObservation: PropTypes.object,
		fetchRecentObservations: PropTypes.func.isRequired,
		gradeLevels: PropTypes.array,
		isFetchingTeachers: PropTypes.bool,
		recentObservations: PropTypes.array,
		router: PropTypes.object.isRequired,
		students: PropTypes.array,
		teachers: PropTypes.array
	},

	getInitialState: function() {
		return {
			instructionDate: moment().format('YYYY-MM-DD'),
			isConfirmingStart: false,
			isCreatingObservation: false,
			isLiveObservation: false,
			isShowingRecentObservations: false,
			numberOfCycles: 2,
			numberOfStudents: 3,
			selectedStudentIds: [],
			selectedStudents: [],
			selectedTeacherId: '',
			selectedTeacher: null,
			studentMinutes: preferences.get('studentMinutes'),
			teacherMinutes: preferences.get('teacherMinutes'),
			validationErrors: {}
		};
	},

	componentWillMount: function() {
		if (this.props.teachers && this.props.teachers.length === 1) {
			this.setState({
				selectedTeacherId: this.props.teachers[0].id,
				selectedTeacher: this.props.teachers[0]
			}, () => {
				this.props.fetchRecentObservations(this.props.classroom.id, this.state.selectedTeacherId);
			});
		}
	},

	componentWillReceiveProps: function(newProps) {
		// If new teachers are received, and there's only one teacher, select them
		if (newProps.teachers && newProps.teachers.length === 1 && propertyHasChanged(this.props.teachers, newProps.teachers)) {
			this.setState({
				selectedTeacherId: newProps.teachers[0].id,
				selectedTeacher: newProps.teachers[0]
			}, () => {
				this.props.fetchRecentObservations(this.props.classroom.id, this.state.selectedTeacherId);
			});
		}

		// If the selected classroom is changed, reset the state
		if (newProps.classroom && propertyHasChanged(this.props.classroom, newProps.classroom)) {
			this.setState(this.getInitialState());
		}
	},

	minimumMinutesSinceLastObservation: 1440,

	handleChangeSelectedTeacher: function(ev) {
		let teacherId = ev.target.value;

		this.setState({
			selectedTeacherId: teacherId,
			selectedTeacher: this.props.teachers.find((teacher) => teacher.id === parseInt(teacherId))
		}, () => {
			this.props.fetchRecentObservations(this.props.classroom.id, teacherId);
		});
	},

	handleChangeObservationParameter: function(ev) {
		let newState = {},
			{ validationErrors } = this.state,
			{ name, value } = ev.target;

		if (validationErrors.name) {
			delete(validationErrors.name);
		}

		value = value.replace(/\D/g, '');
		newState[name] = value;
		newState.validationErrors = validationErrors;
		this.setState(newState);
	},

	handleChangeInstructionDate: function(ev) {
		let { validationErrors } = this.state;
		if (validationErrors.instructionDate) {
			delete(validationErrors.instructionDate);
		}
		this.setState({ instructionDate: ev.target.value });
	},

	getFormGroupClass: function(name) {
		let className = 'form-group';
		if (this.state.validationErrors[name]) {
			className += ' has-error';
		}
		return className;
	},

	handleChangeNumberOfStudents: function(ev) {
		this.setState({ numberOfStudents: parseInt(ev.target.value) });
	},

	handleSelectStudent: function(index, studentId) {
		let { selectedStudentIds, selectedStudents } = this.state;
		selectedStudentIds[index] = parseInt(studentId);
		selectedStudents[index] = this.props.students.find((student) => student.id === parseInt(studentId));
		this.setState({ selectedStudentIds, selectedStudents });
	},

	resetSelectedStudent: function(index) {
		let { selectedStudentIds, selectedStudents } = this.state;
		delete(selectedStudentIds[index]);
		delete(selectedStudents[index]);
		this.setState({ selectedStudentIds });
	},

	getSelectStudentsContent: function() {
		let { numberOfStudents, selectedStudentIds } = this.state,
			gradeEquivalent = null,
			output = [];

		if (this.props.classroom) {
			this.props.gradeLevels.every((gradeLevel) => {
				if (gradeLevel.id === this.props.classroom.grade_level_id) {
					gradeEquivalent = gradeLevel.grade_equivalent;
				} else {
					return true;
				}
			});

			_.times(this.state.numberOfStudents, (index) => {
				let studentId = selectedStudentIds[index];

				output.push(
					<SelectStudent
						getLastObservationDate={ this.getLastObservationDate }
						gradeLevel={ gradeEquivalent }
						key={ 'select-students-' + index }
						label={ 'Student #' + (index + 1) }
						minimumMinutesSinceLastObservation={ this.minutesSinceLastObservation }
						onChange={ (studentId) => {
							this.handleSelectStudent(index, studentId);
						} }
						resetSelection={ () => this.resetSelectedStudent(index) }
						selectedStudentId={ studentId }
						allSelectedStudentIds={ this.state.selectedStudentIds }
						students={ this.props.students }
					/>
				);
			});
		}

		return output;
	},

	handleStart: function(ev) {
		ev.preventDefault();

		if (this.props.currentObservation) {
			this.setState({ isConfirmingStart: true });
		} else {
			this.startObservation();
		}
	},

	startObservation: function() {
		let errors = [];
		let requiredParameters = [
			'selectedTeacherId',
			'numberOfCycles',
			'studentMinutes',
			'teacherMinutes',
			'instructionDate'
		];

		requiredParameters.map((parameter) => {
			let valueInState = this.state[parameter];
			if (typeof(valueInState) === 'undefined' || valueInState === '') {
				errors[parameter] = 'This field is required';
			}
		});

		if (this.state.numberOfCycles < 1) {
			errors['numberOfCycles'] = 'You must perform at least 1 observation cycle';
		}

		if (!this.state.selectedStudentIds.length) {
			errors.selectedStudentIds = 'Please select at least one student to observe';
		}

		this.setState({ validationErrors: errors });

		if (Object.keys(errors).length) {
			return false;
		} else {
			let preferencesInState = ['numberOfCycles', 'studentMinutes', 'teacherMinutes'];
			preferencesInState.map((name) => {
				preferences.set(name, this.state[name]);
			});

			let instructionDate;
			if (this.state.isLiveObservation) {
				instructionDate = moment().format('YYYY-MM-DD');
			} else {
				instructionDate = this.state.instructionDate;
			}

			let observation = {
				classroom: _.pick(this.props.classroom, ['id', 'description', 'grade_level_id']),
				classroom_id: this.props.classroom.id,
				number_of_cycles: parseInt(this.state.numberOfCycles),
				observation_date: instructionDate,
				student_ids: this.state.selectedStudentIds.filter((n) => {
					return n !== undefined;
				}),
				student_minutes: parseInt(this.state.studentMinutes),
				students: this.state.selectedStudents,
				teacher: this.state.selectedTeacher,
				teacher_id: parseInt(this.state.selectedTeacherId),
				teacher_minutes: parseInt(this.state.teacherMinutes),
			};

			this.setState({ isCreatingObservation: true });
			this.props.createObservation(observation);

			// Reset the timer when creating a new observation
			localStorage.setItem('currentCycleElapsedSeconds', 0);

			this.props.router.push('/observations/current');
		}
	},

	getLastObservationDate: function(studentId) {
		let lastObservationDate = null;

		this.props.recentObservations.every((observation) => {
			if (observation.student_id === studentId) {
				lastObservationDate = observation.date;
				return false;
			} else {
				return true;
			}
		});

		if (lastObservationDate) {
			lastObservationDate = moment.utc(lastObservationDate).local().format('YYYY-MM-DD h:mma');
		}

		return lastObservationDate;
	},

	getObservationTableRowClass: function(localObservationDate) {
		if (localObservationDate) {
			let minutesSinceLastObservation = moment().local().diff(moment(localObservationDate, 'YYYY-MM-DD h:mma'), 'minutes');

			if (minutesSinceLastObservation < this.minimumMinutesSinceLastObservation) {
				return 'excluded';
			}
		}

		return '';
	},

	render: function() {
		let { teachers } = this.props;
		if (teachers && teachers.asMutable) {
			teachers = teachers.asMutable();
		}

		return(
			<div className="observation-setup container">
				<h2>New Observation</h2>
				<SelectDistrictSchoolAndClassroom />
				{
					!this.props.classroom ? '' : (
						this.props.isFetchingTeachers ? (
							<span>Loading teachers... <LoadingSpinner /></span>
						) : (
							// SELECT TEACHER
							teachers && teachers.length ? (
								<div className="teacher-selection">
									<h3>Select Teacher</h3>
									<div className="form-group">
										<select
											className="form-control"
											name="teacher"
											value={ this.state.selectedTeacherId ? this.state.selectedTeacherId : '' }
											onChange={ this.handleChangeSelectedTeacher }
										>
											<option value='' hidden>Select...</option>
											{
												teachers.map((teacher) => {
													return (
														<option value={ teacher.id } key={ 'teacher-' + teacher.id }>
															{ teacher.last_name + ', ' + teacher.first_name }
														</option>
													);
												})
											}
										</select>
									</div>
								</div>
							) : (
								<div className="no-teachers-found">
									No teachers have been assigned to this classroom.
								</div>
							)
						)
					)
				}
				{
					this.state.selectedTeacherId && this.props.classroom ? (
						<div className="observation-parameters">
							<h3>Observation Setup</h3>
							<div className="recorded-or-live">
								<label>Is this a recorded or live observation?</label>
								<div>
									<div className="btn-group">
										<button
											type="button"
											onClick={ () => this.setState({ isLiveObservation: false }) }
											className={ this.state.isLiveObservation ? 'btn btn-default' : 'btn btn-default active' }
										>
											Recorded
										</button>
										<button
											type="button"
											onClick={
												() => {
													this.setState({
														isLiveObservation: true,
														instructionDate: moment().format('YYYY-MM-DD')
													});
												}
											}
											className={ this.state.isLiveObservation ? 'btn btn-default active' : 'btn btn-default' }
										>
											Live
										</button>
									</div>
								</div>
								<div className={ this.getFormGroupClass('instructionDate') }>
									<label>Instruction date</label>
									<input
										className="form-control"
										name="instructionDate"
										disabled={ this.state.isLiveObservation }
										type="date"
										value={ this.state.instructionDate }
										onChange={ this.handleChangeInstructionDate }
									/>
									{
										this.state.validationErrors.instructionDate ? (
											<div className="validation-error">{ this.state.validationErrors.instructionDate }</div>
										) : ''
									}
								</div>
							</div>
							<div className="parameter-row">
								<div className={ this.getFormGroupClass('numberOfCycles') }>
									<label>Number of cycles</label>
									<input
										className="form-control"
										type="number"
										name="numberOfCycles"
										value={ this.state.numberOfCycles }
										onChange={ this.handleChangeObservationParameter }
									/>
									{
										this.state.validationErrors.numberOfCycles ? (
											<div className="validation-error">{ this.state.validationErrors.numberOfCycles }</div>
										) : ''
									}
								</div>
								<div className={ this.getFormGroupClass('studentMinutes') }>
									<label>Student minutes</label>
									<input
										className="form-control"
										type="number"
										name="studentMinutes"
										value={ this.state.studentMinutes }
										onChange={ this.handleChangeObservationParameter }
									/>
									{
										this.state.validationErrors.studentMinutes ? (
											<div className="validation-error">{ this.state.validationErrors.studentMinutes }</div>
										) : ''
									}
								</div>
								<div className={ this.getFormGroupClass('teacherMinutes') }>
									<label>Teacher minutes</label>
									<input
										className="form-control"
										type="number"
										name="teacherMinutes"
										value={ this.state.teacherMinutes }
										onChange={ this.handleChangeObservationParameter }
									/>
									{
										this.state.validationErrors.teacherMinutes ? (
											<div className="validation-error">{ this.state.validationErrors.teacherMinutes }</div>
										) : ''
									}
								</div>
							</div>
							<div className="select-students">
								<h3>Select Students</h3>
								<div className="select-students-controls">
									<div className="form-group">
										<label>Number of students to observe</label>
										<select
											className="form-control number-of-students-control"
											value={ this.state.numberOfStudents }
											onChange={ this.handleChangeNumberOfStudents }
										>
											{
												_.times(5, (index) => {
													return (<option value={ index + 1 } key={ index + 1 }>{index + 1}</option>);
												})
											}
										</select>
									</div>
									<button
										className="btn btn-info"
										onClick={ () => this.setState({ isShowingRecentObservations: true }) }
									>
										View excluded students
									</button>
								</div>
								{
									this.state.validationErrors.selectedStudentIds ? (
										<div className="validation-error">
											{ this.state.validationErrors.selectedStudentIds }
										</div>
									) : ''
								}
								{ this.getSelectStudentsContent() }
							</div>
							<button
								className="btn btn-lg btn-primary start-observation"
								onClick={ this.handleStart }
								disabled={
									this.state.isCreatingObservation ||
									this.state.selectedStudentIds.filter((studentId) => Boolean(studentId)).length === 0
								}
							>
								{
									this.state.isCreatingObservation ? (
										<span>
											<i className="glyphicon glyphicon-refresh glyphicon-spin" />
											{' '}
											Loading
										</span>
									) : (
										<span>
											<i className="glyphicon glyphicon-ok" />
											{' '}
											Start
										</span>
									)
								}
							</button>
						</div>
					) : ''
				}
				<Modal
					className="recent-observations"
					show={ this.state.isShowingRecentObservations }
					onHide={ () => this.setState({ isShowingRecentObservations: false }) }
				>
					<Modal.Header
						closeButton={ true }
						onHide={ () => this.setState({ isShowingRecentObservations: false }) }
					>
						<h4>Most Recent Observation Dates</h4>
					</Modal.Header>
					<Modal.Body>
						<div className="legend">
							Students in <span className="excluded">red</span> will be excluded from random selection because they have been observed in the last 24 hours.  They can still be manually selected.
						</div>
						<table className="table table-striped table-condensed">
							<thead>
								<tr>
									<th>Name</th>
									<th>Last observed</th>
								</tr>
							</thead>
							<tbody>
								{
									_.sortBy(this.props.students, ['last_name', 'first_name']).map((student) => {
										let observationDate = this.getLastObservationDate(student.id);

										return (
											<tr
												key={ 'last-observation-' + student.id }
												className={ this.getObservationTableRowClass(observationDate) }
											>
												<td>
													{ student.last_name + ', ' + student.first_name }
												</td>
												<td>
													{ observationDate ? observationDate : 'Never' }
												</td>
											</tr>
										);
									})
								}
							</tbody>
						</table>
					</Modal.Body>
					<Modal.Footer>
					</Modal.Footer>
				</Modal>
				<ConfirmationModal
					body="Starting a new observation will overwrite your observation in progress.  Are you sure you want to do this?"
					cancelButtonStyle="default"
					cancelButtonText="Cancel"
					confirmationButtonStyle="warning"
					confirmationButtonText="Start"
					isProcessing={ false }
					onCancel={ () => this.setState({ isConfirmingStart: false }) }
					onConfirm={ this.startObservation }
					shouldShow={ this.state.isConfirmingStart }
					title="Warning!"
				/>
			</div>
		);
	}
});

module.exports = ObservationSetup;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/ObservationSetup.jsx